import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ArtigosPaginados } from './../classes/artigos-paginados';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArticleListService {
  private endpoint = environment.urlAPI + '/categoria/artigos';

  constructor(private http: HttpClient) {}

  getArticleList(categoria: string, pagina: number, limite: number) {
    return this.http.post<ArtigosPaginados>(
      this.endpoint,
      JSON.stringify({ categoria: categoria, pagina: pagina, limite: limite }),
    );
  }
}
